//
// formatChartDateOffset;
//
// Take in a JS date, output a date depending on the chart precision
//
// When precision is above the day level, add 1h to the time to account
// for time change (midnight bein potentially pushed back to the day before)
//
// input
//
// date             The JS Date object
// displayPeriod    Chart precision, 'hours', 'days', 'weeks', 'months', 'years'
// locale           A date-fns/locale object
// type             'xAxis': for the chart xAxis, compact date
//                  'tooltip': for the tooltip content, longer
//

import { format, addDays } from 'date-fns';

import {
  logError,
  stringUpperCaseFirstLetter,
} from '../../utils';

const formatChartDate = (date, displayPeriod, locale, type) => {
  let ret = '?';

  try {
    const dateOffset = new Date(date);

    // For hours, we don't add the 1h offset since we want precise hour display
    if (displayPeriod !== 'hours') {
      dateOffset.setHours(dateOffset.getHours() + 1);
    }

    if (displayPeriod === 'years') {
      ret = format(dateOffset, 'yyyy', { locale });
    } else if (displayPeriod === 'months') {
      if (['xAxis'].includes(type)) ret = format(dateOffset, 'MMM yy', { locale });

      // 'tooltip'
      else ret = format(dateOffset, 'MMMM yyyy', { locale });
    } else if (displayPeriod === 'weeks') {
      if (['xAxis'].includes(type)) {
        ret = format(dateOffset, 'd MMM', { locale });
      } else {
        // 'tooltip'
        ret = `${format(dateOffset, 'd MMM', { locale })} - ${
          format(addDays(dateOffset, 6), 'd MMM yyyy', { locale })}`;
      }
    } else if (displayPeriod === 'hours') {
      if (['xAxis'].includes(type)) {
        // Short format: show hour and day if it's not today
        const now = new Date();
        const isToday = dateOffset.toDateString() === now.toDateString();

        if (isToday) {
          ret = format(dateOffset, 'HH:mm', { locale });
        } else {
          ret = format(dateOffset, 'd/M HH:mm', { locale });
        }
      } else {
        // 'tooltip' - longer format
        ret = format(dateOffset, 'EEEE dd MMMM yyyy HH:mm', { locale });
      }
    } else if (['xAxis'].includes(type)) {
      // if (displayPeriod === 'days')
      ret = format(dateOffset, 'd MMM', { locale });
    } else {
      // 'tooltip'
      ret = format(dateOffset, 'EEEE dd MMMM yyyy', { locale });
    }
  } catch (err) {
    logError(
      `formatChartDate err=${err}`,
      'formatChartDate.formatError',
      {
        err: err?.message,
        displayPeriod,
        type,
        time: date && new Date(date).getTime(),
      },
    );
  }

  return stringUpperCaseFirstLetter(ret);
};

export default formatChartDate;
